import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import { openCallReason } from "@/lib/site";

export function SubPageShell({ children, callSource = "pagina-servizio" }) {
  return (
    <div className="min-h-screen bg-[#12100E]">
      <header className="fixed top-0 z-50 w-full border-b border-[#2A241F] bg-[#12100E]/92 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Link to="/" data-testid="subpage-home-link" className="group flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tighter text-[#FAF7F2]">
              <span className="text-[#E05A2C]">YU</span> YIELDUP
            </span>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#A89F91]">Revenue Management</span>
          </Link>
          <div className="flex items-center gap-3">
            <Link
              to="/"
              data-testid="subpage-back-home"
              className="hidden text-xs text-[#A89F91] underline decoration-[#383029] underline-offset-4 transition-colors duration-300 hover:text-[#FAF7F2] sm:inline sm:text-sm"
            >
              Torna alla home
            </Link>
            <button
              data-testid="subpage-book-call-button"
              onClick={() => openCallReason(callSource)}
              className="btn-glow inline-flex min-h-[44px] items-center whitespace-nowrap rounded-full bg-[#E05A2C] px-5 py-3 text-xs font-medium text-white transition-colors duration-300 hover:bg-[#F26B3A] sm:px-6 sm:text-sm"
            >
              Prenota una chiamata
            </button>
          </div>
        </div>
      </header>
      <main className="pt-24 sm:pt-28">{children}</main>
      <Footer />
    </div>
  );
}

export function ProfessionalBadge({ photo, name, caption, testid }) {
  return (
    <div data-testid={testid} className="mt-8 flex items-center gap-5">
      <div className="shrink-0 -rotate-3 border-4 border-[#F7F4EC] bg-[#F7F4EC] shadow-[0_12px_30px_rgba(0,0,0,0.45)]">
        <img src={photo} alt={name} className="h-24 w-20 object-cover grayscale contrast-110 sm:h-28 sm:w-24" />
      </div>
      <p className="max-w-[260px] text-sm leading-snug text-[#C4BBB0]">
        <span className="font-medium text-[#FAF7F2]">{name}.</span> {caption}
      </p>
    </div>
  );
}

export function PageFaq({ items }) {
  return (
    <div data-testid="subpage-faq" className="mt-6 space-y-3">
      {items.map((f, i) => (
        <div key={f.q} data-testid={`subpage-faq-${i + 1}`} className="border border-[#2A241F] p-6">
          <p className="font-heading text-base font-black uppercase tracking-tight text-[#FAF7F2]">{f.q}</p>
          <p className="mt-3 text-sm font-light leading-relaxed text-[#C4BBB0] sm:text-base">{f.a}</p>
        </div>
      ))}
    </div>
  );
}
